export const SITE = {
  name: "Alliance Crane Service LLC",
  shortName: "Alliance Crane Service",
  tagline: "Heavy Lifting. Done Right.",
  city: "DeLand",
  state: "Florida",
  phone: "(386) 506-7771",
  phoneE164: "+13865067771",
  email: "alliancecrane38@gmail.com",
  address: "DeLand, Florida 32720",
  hours: "Mon–Fri 7:00 AM – 5:00 PM",
  emergencyHours: "24/7 Emergency Service",
  logo: "https://customer-assets.emergentagent.com/job_93e462b3-add9-4d5f-b088-07d4f2e06aab/artifacts/zrtgs0ni_0A1097E8-49C6-4D12-BC17-3DF1FE816D52.PNG",
  googleReviewUrl: "https://g.page/r/CfsvHW27XSxqEAI/review",
};

export const SERVICES = [
  {
    slug: "crane-rental-operator",
    title: "Crane Rental With Operator",
    short: "Certified, insured operators with every lift.",
    description:
      "Bare crane plus a seasoned NCCCO-certified operator. We arrive job-ready, signal-trained and OSHA compliant — you get safe productive lifts on schedule.",
    icon: "Construction",
  },
  {
    slug: "hydraulic-mobile-crane",
    title: "Hydraulic Mobile Crane Services",
    short: "Truck-mounted hydraulic boom cranes.",
    description:
      "Fast-setup hydraulic mobile cranes for tight sites, infill construction and one-day picks. Highway legal, urban friendly.",
    icon: "Truck",
  },
  {
    slug: "hvac-placement",
    title: "HVAC Equipment Placement",
    short: "Rooftop unit & chiller sets.",
    description:
      "Precision rooftop AHU, RTU and chiller placement. We coordinate with mechanical contractors and stage units exactly where they need to land.",
    icon: "Wind",
  },
  {
    slug: "steel-erection",
    title: "Steel Erection",
    short: "Structural steel & beam picks.",
    description:
      "Beam-by-beam erection for warehouses, retail shells and light-industrial structures. Tight tolerance, fast cycle, safety-first picks.",
    icon: "Building2",
  },
  {
    slug: "machinery-moving",
    title: "Machinery Moving",
    short: "Heavy equipment relocation.",
    description:
      "Loading, offloading and positioning industrial machinery — generators, transformers, presses, CNCs, tanks and more.",
    icon: "Cog",
  },
  {
    slug: "truss-lifts",
    title: "Truss Lifts",
    short: "Residential & commercial trusses.",
    description:
      "Pre-engineered wood and steel truss setting for new builds and additions. Coordinated drops keep your framing crew moving.",
    icon: "Triangle",
  },
  {
    slug: "emergency-lifting",
    title: "Emergency Lifting Services",
    short: "24/7 storm, accident & rescue lifts.",
    description:
      "Tree-on-house, vehicle recovery, post-storm structural lifts, equipment failures — on call around the clock for Central Florida.",
    icon: "Siren",
  },
];

export const FLEET = [
  {
    slug: "grove-40-ton",
    name: "Grove 40-Ton",
    capacity: "40 Tons",
    type: "Hydraulic Truck Crane",
    boom: "Up to 105 ft main boom",
    jib: "Available",
    image:
      "https://customer-assets.emergentagent.com/job_heavy-lift-solutions-3/artifacts/fabzdy7b_379E0A4F-9557-483E-91F7-55A4134B3FAF-800x600.jpeg",
    blurb:
      "Versatile, road-friendly 40-ton mobile crane. Ideal for HVAC sets, residential truss work and mid-rise steel.",
    specs: [
      { label: "Capacity", value: "40 Tons" },
      { label: "Main Boom", value: "~105 ft" },
      { label: "Reach with Jib", value: "Available" },
      { label: "Engine", value: "Diesel" },
      { label: "Drive", value: "All-Terrain Capable" },
    ],
  },
  {
    slug: "manitex-50-ton",
    name: "Manitex 50-Ton",
    capacity: "50 Tons",
    type: "Boom Truck",
    boom: "Up to 155 ft main boom",
    jib: "Optional 31 ft jib",
    image:
      "https://customer-assets.emergentagent.com/job_heavy-lift-solutions-3/artifacts/08j7l5sd_IMG_4360.jpeg",
    blurb:
      "High-capacity 50-ton boom truck for steel erection, machinery moving and longer-reach commercial picks.",
    specs: [
      { label: "Capacity", value: "50 Tons" },
      { label: "Main Boom", value: "~155 ft" },
      { label: "Reach with Jib", value: "+31 ft optional" },
      { label: "Mount", value: "Heavy-Duty Truck" },
      { label: "Setup", value: "Fast Outrigger Deploy" },
    ],
  },
];

export const SERVICE_AREAS = [
  { city: "DeLand", state: "FL", note: "Headquarters" },
  { city: "Orlando", state: "FL" },
  { city: "Daytona Beach", state: "FL" },
  { city: "Jacksonville", state: "FL" },
  { city: "Titusville", state: "FL" },
  { city: "Sanford", state: "FL" },
  { city: "Lake Mary", state: "FL" },
  { city: "Ormond Beach", state: "FL" },
  { city: "New Smyrna Beach", state: "FL" },
  { city: "Kissimmee", state: "FL" },
  { city: "Melbourne", state: "FL" },
  { city: "Palm Coast", state: "FL" },
];

export const STATS = [
  { value: "2", label: "Mobile Cranes" },
  { value: "90 Ton", label: "Combined Capacity" },
  { value: "24/7", label: "Emergency Dispatch" },
  { value: "100%", label: "Licensed & Insured" },
];
